export const briefcase = () => (
  <path
    d="M22 9a2 2 0 00-2-2H4a2 2 0 00-2 2m20 0v10a2 2 0 01-2 2H4a2 2 0 01-2-2V9m20 0v3a2 2 0 01-2 2H4a2 2 0 01-2-2V9m12 5v1a2 2 0 11-4 0v-1m6-7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
